import { render, staticRenderFns } from "./RuleList.vue?vue&type=template&id=668d539f&scoped=true"
import script from "./RuleList.vue?vue&type=script&lang=js"
export * from "./RuleList.vue?vue&type=script&lang=js"
import style0 from "./RuleList.vue?vue&type=style&index=0&id=668d539f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668d539f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('668d539f')) {
      api.createRecord('668d539f', component.options)
    } else {
      api.reload('668d539f', component.options)
    }
    module.hot.accept("./RuleList.vue?vue&type=template&id=668d539f&scoped=true", function () {
      api.rerender('668d539f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sorting/RuleList.vue"
export default component.exports